<script setup>
// Thin wrapper around saas-core's LoginForm. The upstream component is
// intentionally hands-off about routing — it emits a `success` event after
// login succeeds and leaves the redirect decision to the consuming app.
//
// Behaviour:
//   - If the URL has a `?redirect=...` query param (set by the voice client
//     when it hits 401), honour it.
//   - Otherwise, push to `/` — the router's per-route guards then route
//     platform-admins into AdminShell and non-admins back out to the
//     vanilla voice client (`/`) via the /voice-loop-redirect fallback.
import { useRouter, useRoute } from "vue-router";
import LoginForm from "@digitalstreams/saas-core/vue/views/LoginForm.vue";

const router = useRouter();
const route = useRoute();

function onSuccess() {
  const target = typeof route.query.redirect === "string" ? route.query.redirect : "/";
  router.push(target);
}
</script>

<template>
  <LoginForm app-name="i-Recall" @success="onSuccess" />
</template>
